<div class="d-flex flex-column">
  <div class="d-flex">
    <div class="align-self-start"><i class="fa fa-list-ol red mr-1"></i></div>
    <div>
      <span>{{ 'phonenumber_type_single' | i18next }}</span>
      @if (locationIndependent) {
        <span> {{ 'location_independent_label' | i18next }}</span>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-auto p-0 m-0" style="min-width: 130px;">
      <div class="text-nowrap">{{ 'phonenumber' | i18next }}:</div>
    </div>
    <div class="col-auto p-0 m-0">
      <div>{{ from | phonenumber }}</div>
    </div>
  </div>
  @if (deliveryDate) {
    <div class="row">
      <div class="col-auto p-0 m-0" style="min-width: 130px;">
        <div class="text-nowrap">{{ 'phonenumber_delivery_date' | i18next }}:</div>
      </div>
      <div class="col-auto p-0 m-0">
        <div class="text-nowrap">{{ deliveryDate | localized_date }}</div>
      </div>
    </div>
  }
</div>